import React from 'react';
import { Container, Surface } from '@infoods/lifebase-ui';

import classes from './NgzSetNewPassword.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { RedirectToMobileApp } from './containers/RedirectToMobileApp/RedirectToMobileApp';
import { RedirectToWebApp } from './containers/RedirectToWebApp/RedirectToWebApp';
import { SetPasswordForm } from './containers/SetPasswordForm/SetPasswordForm';
import { useStepper } from '../../../shared/hooks/useStepper';
import { NgzPageNotFound } from '../../../shared/containers/NgzPageNotFound/NgzPageNotFound';
import { getAccessParamsFromUrl } from '../../../shared/utils/apiUtils';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { SwymoHeader } from '../../../shared/components/header-components/SwymoHeader/SwymoHeader';

const NgzSetNewPassword = () => {
  const { activeStep, goToNextStep } = useStepper(0);

  const { accessParams, allParamsExist } = getAccessParamsFromUrl();
  const redirectType = getRouteParam('redirectType');

  if (!allParamsExist) {
    return <NgzPageNotFound />;
  }

  const SuccessRedirect =
    redirectType === 'WEB' ? <RedirectToWebApp /> : <RedirectToMobileApp />;

  const stepsComponent = [
    <SetPasswordForm
      key="set-password-form"
      goToNextStep={goToNextStep}
      accessParams={accessParams}
    />,
    SuccessRedirect,
  ];

  return (
    <>
      <SwymoHeader inAngularContainer variant="dark" />
      <Container className={classes.block}>
        <Surface className={classes.scholasticSetNewPassword}>
          {stepsComponent[activeStep]}
        </Surface>
      </Container>
    </>
  );
};

angularizeWithProviders(NgzSetNewPassword, 'ngzSetNewPassword', {});

export default NgzSetNewPassword;
